import { Component, Input, OnInit } from '@angular/core';
import { WikiService } from '../services/wiki.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';

@Component({
    selector: 'lock-wiki',
    template: `<a class="btn"
    title="{{'Lock / unlock for editing' | translate}}"
    (click)="toggleLocked()"
    [ngClass]="{ 'btn-success': isLocked, 'btn-trans': !isLocked }">
    <i class="glyphicon glyphicon-lock"></i>
</a>`
})
export class LockWikiComponent implements OnInit {

    @Input() project: any;
    @Input() wikiPage: any;
    @Input() lockStatus: any;

    private lockStatuses = {
        locked: 1,
        unlocked: 0
    };
    protected isLocked = 0;
    private enableLocking: boolean = true;
    private lockOptions = {};

    constructor(
        private wikiService: WikiService,
        private gfTranslateService: GfTranslateService,
        private stateService: StateService
    ) { }
    
    ngOnInit() {
        this.isLocked = _.get(this.lockStatus, 'flags', this.lockStatuses.unlocked)

        this.lockOptions[this.gfTranslateService.translate('Locked')] = this.lockStatuses.locked;
        this.lockOptions[this.gfTranslateService.translate('Unlocked')] = this.lockStatuses.unlocked;

        this.enableLocking =
            _.get(this.project, 'rel.permissions.wiki', 0) >= 99 &&
            _.get(this.wikiPage, 'id', false);
    };

    toggleLocked = () => {
        var newStatus = (this.isLocked == this.lockStatuses.locked) ? this.lockStatuses.unlocked : this.lockStatuses.locked;
        this.wikiService.postLock(this.wikiPage.id, { lock_status: newStatus, project: this.stateService.params.unixName })
        .then(() => {
            this.isLocked = newStatus;
            // Can't edit if you just locked it.
            if (newStatus && this.stateService.current.name == 'home.project.summary.wiki.page.edit') {
                this.stateService.go('^', this.stateService.params, { reload: true });
            }
        }, (result) => {
            console.log('toggleLocked', result);
        });
    };
}